export const nullFunction = () => null;

export const notImplementedYet = () => window.alert("NOT implemented");
